// "최근 변경" 피드 열람 상태 (클라이언트 전용)
// navbar 배지 · correct/analyze 위젯 · /update-logs 피드 뷰가 공유한다.
const STORAGE_KEY = 'bareun.update-feed.seen';

export const UPDATE_FEED_SEEN_EVENT = 'bareun:update-feed-seen';

export function getSeenUpdateDate(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

// YYYY-MM-DD 문자열 비교로 충분
export function isUpdateFeedNew(latestDate: string): boolean {
  const seen = getSeenUpdateDate();
  return !seen || latestDate > seen;
}

export function markUpdateFeedSeen(latestDate: string) {
  try {
    window.localStorage.setItem(STORAGE_KEY, latestDate);
  } catch {
    // localStorage 비활성 환경에서는 열람 상태를 저장하지 않는다
  }
  // 같은 탭의 배지/위젯이 즉시 갱신되도록 알린다 (storage 이벤트는 cross-tab 전용)
  window.dispatchEvent(new Event(UPDATE_FEED_SEEN_EVENT));
}
